export default {
	type: 'object',
	properties: {
		whitelistType: { type: 'string' },
		campaignId: { type: 'string' },
	},
	required: [],
	additionalProperties: false,
}
